export enum LocalStorageItemEnum {
  HOTEL_SEARCH_DESTINATION_HISTORIES = "HOTEL_SEARCH_DESTINATION_HISTORIES",
  FLIGHT_SEARCH_DESTINATION_HISTORIES = "FLIGHT_SEARCH_DESTINATION_HISTORIES",
  FLIGHT_SEARCH_HISTORIES = "FLIGHT_SEARCH_HISTORIES",
  HOTEL_SEARCH_QUERY_STRING = "HOTEL_SEARCH_QUERY_STRING",
  FLIGHT_SEARCH_QUERY_STRING = "FLIGHT_SEARCH_QUERY_STRING",
  FLIGHT_ERROR_CODE = "FLIGHT_ERROR_CODE",
  HOTEL_RECENTLY_VIEWED = "HOTEL_RECENTLY_VIEWED",
  DISTANCE_UNIT = "DISTANCE_UNIT",
  PRICE_DISPLAY = "PRICE_DISPLAY",
  SAVE_FLIGHT_CURRENT_TAB = "SAVE_FLIGHT_CURRENT_TAB",
  FLIGHT_SEARCH_RESULT = "FLIGHT_SEARCH_RESULT",
  HOTEL_SLUG = "HOTEL_SLUG",
  FLIGHT_SEARCH_REQUEST = "FLIGHT_SEARCH_REQUEST",
  CURRENT_DATE = "CURRENT_DATE",
  CURRENT_MONTH = "CURRENT_MONTH",
  HOLIDAY = "HOLIDAY",
  FLIGHT_SELECTED_KEEP = "FLIGHT_SELECTED_KEEP",
  HOTEL_ITEM_LIST_NAME = "HOTEL_ITEM_LIST_NAME",
  FLIGHT_ITEM_LIST_NAME = "FLIGHT_ITEM_LIST_NAME",
  EXPERIENCE_TICKET_QUERY_STRING = "EXPERIENCE_TICKET_QUERY_STRING",
  EXPERIENCE_SEARCH_DESTINATION_HISTORIES = "EXPERIENCE_SEARCH_DESTINATION_HISTORIES",
  CAR_RENTAL_SEARCH_DESTINATION_HISTORIES_CWD = "CAR_RENTAL_SEARCH_DESTINATION_HISTORIES_CWD",
  CAR_RENTAL_SEARCH_DESTINATION_HISTORIES_COL = "CAR_RENTAL_SEARCH_DESTINATION_HISTORIES_COL",
  EXPERIENCE_RECENTLY_VIEWED = "EXPERIENCE_RECENTLY_VIEWED",
  TOUR_PACKAGE_RECENTLY_VIEWED = "TOUR_PACKAGE_RECENTLY_VIEWED",
  EXPERIENCE_EVENT_RECENTLY_VIEWED = "EXPERIENCE_EVENT_RECENTLY_VIEWED",
  TOURS_SEARCH_HISTORY = "TOURS_SEARCH_HISTORY",
  CHATBOT_OPENED = "CHATBOT_OPENED",
  FLIGHT_DEPARTURE_SEARCH_TYPE = "FLIGHT_DEPARTURE_SEARCH_TYPE",
  FLIGHT_ARRIVAL_SEARCH_TYPE = "FLIGHT_ARRIVAL_SEARCH_TYPE",
  FLIGHT_ADDITIONAL_BAGGAGE_STORE = "flightAdditionalBaggageStore",
  HOTEL_SEARCH_CRITERIA = "HOTEL_SEARCH_CRITERIA",
  CAR_SEARCH_CRITERIA = "CAR_SEARCH_CRITERIA",

  // fallback by lib
  i18nextLng = "i18nextLng",

  // GA
  BEGIN_FLOW = "BEGIN_FLOW",

  HOTEL_REDIRECT_BACK_PATH = "HOTEL_REDIRECT_BACK_PATH",

  // flight booking
  FLIGHT_BOOKING_DETAIL = "FLIGHT_BOOKING_DETAIL",

  DIRECT_FLIGHT = "DIRECT_FLIGHT",

  // hear like
  CACHE_HEART_LIKE = "CACHE_HEART_LIKE",

  // Klub Experience
  KLUB_EXPERIENCES = "KLUB_EXPERIENCES",

  // Experiences
  EXPERIENCES = "EXPERIENCES",

  // Flight add ons
  FLIGHT_ADDS_ON = "FLIGHT_ADDS_ON",

  // PROMOTION_LANDING
  PROMOTION_LANDING = "PROMOTION_LANDING",
  PROMOTION_LANDING_COUPONCODE = "PROMOTION_LANDING_COUPONCODE",
  PROMOTION_FLIGHT_SEARCH_QUERY = "PROMOTION_FLIGHT_SEARCH_QUERY",
  PROMOTION_STATIC_COUPONCODE = "PROMOTION_STATIC_COUPONCODE",

  // HOTEL PROMO LANDING
  GA_HOTEL_PROMO_SEARCH = "GA_HOTEL_PROMO_SEARCH",
  GA_HOTEL_PROMO_SEARCH_TEXT = "GA_HOTEL_PROMO_SEARCH_TEXT",
  GA_FLIGHT_PROMO_SEARCH = "GA_FLIGHT_PROMO_SEARCH_TEXT",
  KEEP_ROUTE_CAR_RENTALS = "KEEP_ROUTE_CAR_RENTALS",

  // Car Rentals
  GA_CAR_RENTAL = "CAR_RENTAL",
  CAR_RENTALS_RECENTLY_VIEWED = "CAR_RENTALS_RECENTLY_VIEWED",
  GA_SEARCH_CAR_RENTAL = "GA_SEARCH_CAR_RENTAL",
  CAR_RENTAL_SEARCH_STATE = "CAR_RENTAL_SEARCH_STATE",

  // Tours
  HOLIDAY_TOUR_ID = "HOLIDAY_ID",
  GA_TOURS_ITEM_LIST = "TOURS_GA",
  TOUR_SEO = "TOUR_SEO",

  // Search bar feature
  GOTHER_SEARCH_BAR = "SEARCH_BAR",
  GOTHER_SEARCH_BAR2 = "SEARCH_BAR2",
  FLIGHT_SEARCH_BAR = "FLIGHT_SEARCH_RESULT",
  IS_FLIGHT_SWITCH = "SEARCH_BAR_IS_SWITCH",

  // FB PIXEL PAGE VIEW 10 SEC
  PAGE_VIEW_10_SEC = "PAGE_VIEW_10_SEC",

  // SAVE SURVEY
  REGISTER_SURVEY = "REGISTER_SURVEY",
  // Chatbot
  CHATBOT_STARTED = "chatStarted",
  CHATBOT_CLOSED = "chatWidgetClosed",
  SAVE_URL_BACK = "SAVE_URL_BACK",

  RE_TAB = "RE_TAB",

  // type search GA
  HOTEL_SEARCH_TYPE = "HOTEL_SEARCH_TYPE",
  TOUR_SEARCH_TYPE = "TOUR_SEARCH_TYPE",
  CARRENTAL_PICKUP_SEARCH_TYPE = "CAR_RENTAL_PICKUP_SEARCH_TYPE",
  CARRENTAL_DROPCAR_SEARCH_TYPE = "CAR_RENTAL_DROPCAR_SEARCH_TYPE",
}
